const transferDay = (date) => {
    let curDay = new Date(date);
    const WEEKDAY = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
    let week = WEEKDAY[curDay.getDay()];
    // console.log(`${date}는${week}`)
    return week
}
export default transferDay;